'use client';

import React from 'react';
import { IconVideo } from '@/features/icons';
import { VideoPlayer } from '@/features/video-player';
import { getCdnUrl } from '@/utils/url';
import SectionHeading from './section-heading';
import { useLanguage } from '../context/language-context-provider';
const ProcessingCenter = () => {
  const {
    t
  } = useLanguage();
  return <div className='homepage-container relative flex flex-col items-center gap-5 lg:mt-30 lg:gap-16' data-sentry-component="ProcessingCenter" data-sentry-source-file="processing-center.tsx">
            <SectionHeading title={t('video')} icon={<IconVideo />} className='mr-4.5 lg:mr-0' data-sentry-element="SectionHeading" data-sentry-source-file="processing-center.tsx" />

            <VideoPlayer url='https://vod.khanoumi.com/products/about_us_vendor.mp4' thumbnail={getCdnUrl('/_toad/images/about-us/video-thumbnail.png')} className='mx-auto max-w-[508px] overflow-hidden rounded lg:max-w-full' showPlayIcon data-sentry-element="VideoPlayer" data-sentry-source-file="processing-center.tsx" />
        </div>;
};
export default ProcessingCenter;